'use client'

import { Page, Card, Layout, Text, BlockStack, List } from '@shopify/polaris'
import {
  SUPPORT_EMAIL,
  SUPPORT_PHONE_DISPLAY,
  SUPPORT_PHONE_LOCAL,
  SUPPORT_PHONE_TEL_HREF,
  SUPPORT_WHATSAPP_URL,
} from '@/lib/contact'

export default function TermsPage() {
  return (
    <Page title="Terms of Service">
      <Layout>
        <Layout.Section>
          <Card>
            <BlockStack gap="400">
              <Text as="h2" variant="headingLg">
                Sigma Sense — Terms of Service
              </Text>
              <Text as="p" variant="bodyMd">
                These Terms govern your use of the Sigma Sense Shopify app (the &quot;App&quot;).
                By installing or using the App, you agree to these Terms.
              </Text>
            </BlockStack>
          </Card>
        </Layout.Section>

        <Layout.Section>
          <Card>
            <BlockStack gap="400">
              <Text as="h3" variant="headingMd">
                1) Use of the App
              </Text>
              <List type="bullet">
                <List.Item>You must have a valid Shopify store and comply with Shopify&apos;s terms.</List.Item>
                <List.Item>You are responsible for configuring courier credentials and settings accurately.</List.Item>
                <List.Item>Do not misuse the App or attempt to access data you are not authorized to access.</List.Item>
              </List>
            </BlockStack>
          </Card>
        </Layout.Section>

        <Layout.Section>
          <Card>
            <BlockStack gap="400">
              <Text as="h3" variant="headingMd">
                2) Data &amp; Privacy
              </Text>
              <Text as="p" variant="bodyMd">
                We process store and order data only to provide analytics, reporting, and courier tracking features.
                Please review our Privacy Policy for details on data collection, retention, and deletion.
              </Text>
            </BlockStack>
          </Card>
        </Layout.Section>

        <Layout.Section>
          <Card>
            <BlockStack gap="400">
              <Text as="h3" variant="headingMd">
                3) Billing &amp; Plans
              </Text>
              <Text as="p" variant="bodyMd">
                Paid plans and add-ons are billed through Shopify Billing. You can upgrade, downgrade, or cancel at
                any time from within the App or your Shopify admin.
              </Text>
            </BlockStack>
          </Card>
        </Layout.Section>

        <Layout.Section>
          <Card>
            <BlockStack gap="400">
              <Text as="h3" variant="headingMd">
                4) Availability &amp; Changes
              </Text>
              <Text as="p" variant="bodyMd">
                We may update or modify the App to improve performance, add features, or comply with policy changes.
              </Text>
            </BlockStack>
          </Card>
        </Layout.Section>

        <Layout.Section>
          <Card>
            <BlockStack gap="400">
              <Text as="h3" variant="headingMd">
                5) Limitation of Liability
              </Text>
              <Text as="p" variant="bodyMd">
                The App is provided &quot;as is&quot; without warranties. Sigma Sense is not liable for indirect or
                consequential damages, including lost profits or business interruptions.
              </Text>
            </BlockStack>
          </Card>
        </Layout.Section>

        <Layout.Section>
          <Card>
            <BlockStack gap="400">
              <Text as="h3" variant="headingMd">
                6) Meta Ads Integration
              </Text>
              <Text as="p" variant="bodyMd">
                If you connect Meta Ads, we have read-only access to ad performance data. We do not create or edit ads.
                OAuth tokens are stored encrypted and access can be revoked at any time. Data retention and deletion
                are available on request. For deletion requests, contact us at{' '}
                <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>
                , phone{' '}
                <a href={SUPPORT_PHONE_TEL_HREF}>{SUPPORT_PHONE_DISPLAY}</a>
                {' '}(within Pakistan: {SUPPORT_PHONE_LOCAL}), or{' '}
                <a href={SUPPORT_WHATSAPP_URL} target="_blank" rel="noopener noreferrer">
                  WhatsApp
                </a>
                .
              </Text>
            </BlockStack>
          </Card>
        </Layout.Section>

        <Layout.Section>
          <Card>
            <BlockStack gap="400">
              <Text as="h3" variant="headingMd">
                7) Contact
              </Text>
              <Text as="p" variant="bodyMd">
                For questions about these Terms, contact us at{' '}
                <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>
                , phone{' '}
                <a href={SUPPORT_PHONE_TEL_HREF}>{SUPPORT_PHONE_DISPLAY}</a>
                {' '}(within Pakistan: {SUPPORT_PHONE_LOCAL}), or{' '}
                <a href={SUPPORT_WHATSAPP_URL} target="_blank" rel="noopener noreferrer">
                  WhatsApp
                </a>
                .
              </Text>
            </BlockStack>
          </Card>
        </Layout.Section>
      </Layout>
    </Page>
  )
}
